import { gql } from "@apollo/client";

export const QUERY_MY_LOAD_LIST = gql`
  query MyLoads($orderBy: [String], $first: Int, $last: Int, $before: String, $after: String) {
    myLoads(orderBy: $orderBy, first: $first, last: $last, before: $before, after: $after) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      data {
        timePosted
        modfied
        id
        originAddress
        destinationAddress
        originCity
        destinationCity
        originState
        destinationState
        originCountry
        destinationCountry
        originIso2
        originIso3
        destinationIso2
        destinationIso3
        originZip
        originAreacode
        destinationZip
        destinationAreacode
        trailerType
        length
        weight
        targetRate
        timeStart
        timeEnd
        timeDelivery
        matchDate
        details
        recentBid
        linehaulRate
        linehaulDistance
        linehaulDuration
        linehaulRoute
        costPerMile
        linehaulCpm
        cargoValue
        userLoadNumber
        isDeleted
        isRateIndex
        originLocations
        destinationLocations
        attachments
        userType
        postTo
        groups
        groupsPostTo
        status
        isAutoGeneratedLoadNumber
        modified
        created
        loadId
        originCoords {
          latitude
          longitude
        }
        destinationCoords {
          latitude
          longitude
        }
        user {
          id
          email
          userType
          contactName
          contactEmail
          address
          city
          state
          country
          contactPhone
          mc
          dot
        }
        assignedUser {
          id
          email
          userType
          contactName
          contactEmail
          city
          state
          country
          contactPhone
          mc
          dot
        }
        fundingRequest {
          id
        }
        bids {
          id
          amount
          bidStatus
          hasBeenUnderBid
          bidderNotes
          modified
          created
          acceptedBy {
            id
            email
            userType
            contactName
            contactEmail
            city
            state
            country
            contactPhone
            mc
            dot
          }
          user {
            id
            email
            userType
            contactName
            contactEmail
            city
            state
            country
            contactPhone
            mc
            dot
          }
        }
      }
    }
  }
`;

export const QUERY_HAULPAY_LOAD_LIST = gql`
  query MyLoads($orderBy: [String], $first: Int, $last: Int, $before: String, $after: String) {
    myLoads(orderBy: $orderBy, first: $first, last: $last, before: $before, after: $after) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      data {
        timePosted
        modfied
        id
        originAddress
        destinationAddress
        originCity
        destinationCity
        originState
        destinationState
        originCountry
        destinationCountry
        originIso2
        originIso3
        destinationIso2
        destinationIso3
        originZip
        originAreacode
        destinationZip
        destinationAreacode
        trailerType
        length
        weight
        targetRate
        timeStart
        timeEnd
        timeDelivery
        matchDate
        details
        recentBid
        linehaulRate
        linehaulDistance
        linehaulDuration
        linehaulRoute
        costPerMile
        linehaulCpm
        cargoValue
        userLoadNumber
        isDeleted
        isRateIndex
        originLocations
        destinationLocations
        attachments
        userType
        postTo
        groups
        groupsPostTo
        status
        isAutoGeneratedLoadNumber
        modified
        created
        loadId
        originCoords {
          latitude
          longitude
        }
        destinationCoords {
          latitude
          longitude
        }
        user {
          id
          email
          userType
          contactName
          contactEmail
          city
          state
          country
          contactPhone
          mc
          dot
        }
        assignedUser {
          id
          email
          userType
          contactName
          contactEmail
          city
          state
          country
          contactPhone
          mc
          dot
        }
        bids {
          id
          amount
          bidStatus
          hasBeenUnderBid
          bidderNotes
          modified
          created
          acceptedBy {
            id
            email
            userType
            contactName
            contactEmail
            city
            state
            country
            contactPhone
            mc
            dot
          }
          user {
            id
            email
            userType
            contactName
            contactEmail
            city
            state
            country
            contactPhone
            mc
            dot
          }
        }
      }
    }
  }
`;

export const MUTATION_DELETE_LOAD = gql`
  mutation DeleteLoad($id: ID!) {
    deleteLoad(id: $id) {
      success
    }
  }
`;
